import React, { Fragment } from "react";
import { convertFromRaw, EditorState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import CircularProgress from "@material-ui/core/CircularProgress";
import Paper from "@material-ui/core/Paper";
import { Row, Col } from "react-flexbox-grid";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import useContent from "./data";

const STATIC_MAP = {
  PROJECT: "El Proyecto",
  CREDITS: "Créditos",
  FAQ: "Preguntas Frecuentes",
  REFERENCES: "Citando",
  PUBLICATIONS: "Publicaciones",
  METHODOLOGY: "Metodología",
  RESEARCHERS: "Investigadores"
};

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    //margin : 24
  },
  title: {
    fontWeight: "bold"
  }
});

function getItemContent({ loading, error, data }, title, page) {
  if (loading) return <CircularProgress />;
  if (error) return `Error!: ${error}`;
  const contentState = convertFromRaw(data.content);
  const editorState = EditorState.createWithContent(contentState);
  return (
    <Fragment>
      <Typography component="h2" variant="h1" gutterBottom align="center">
        {title ? title : STATIC_MAP[page]}
      </Typography>
      <Editor editorState={editorState} toolbarHidden />
    </Fragment>
  );
}

const StaticContent = ({ page, classes, title }) => {
  const state = useContent(page);
  const content = getItemContent(state, title, page);
  return (
    <Row>
      <Col xs={12} md={10} lg={8} mdOffset={1} lgOffset={2}>
        <Paper elevation={1} className={classes.root}>
          {content}
        </Paper>
      </Col>
    </Row>
  );
};

StaticContent.propTypes = {
  page: PropTypes.string,
  classes: PropTypes.object,
  title: PropTypes.string
};

export default withStyles(styles)(StaticContent);



// WEBPACK FOOTER //
// ./src/components/static/index.js